import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import { createRef, useCallback, useState } from "react";
import React from "react";
import { useDropzone } from "react-dropzone";
import { handleFileUpload, handleFileUploadInChunks, handleFileUploadWithOverride, } from "./utils";
export const fileIsImage = (mimetype) => /^image\//.test(mimetype);
export var FileUploadState;
(function (FileUploadState) {
    FileUploadState["initial"] = "initial";
    FileUploadState["loading"] = "loading";
    FileUploadState["success"] = "success";
    FileUploadState["error"] = "error";
})(FileUploadState || (FileUploadState = {}));
export const FileUploader = (props) => {
    const { onLoad, onError, onSuccess } = props.uploadOptions;
    const [file, setFile] = useState(props.initialUploadedFile
        ? {
            state: FileUploadState.success,
            uploaded: props.initialUploadedFile,
        }
        : {
            state: FileUploadState.initial,
        });
    const onRemove = () => setFile({
        state: FileUploadState.initial,
    });
    const handleOnLoad = (file) => onLoad ? onLoad(file || undefined) : null;
    const onLoadWrapper = (file) => {
        setFile({
            state: FileUploadState.loading,
            attempted: file,
        });
        onLoad === null || onLoad === void 0 ? void 0 : onLoad(file);
    };
    const onSuccessWrapper = (file) => {
        setFile({
            state: FileUploadState.success,
            uploaded: file,
        });
        onSuccess(file);
    };
    const onErrorWrapper = (e, file) => {
        setFile({
            state: FileUploadState.error,
            attempted: file,
        });
        onError(e, file);
    };
    const upload = (files) => {
        if (props.uploadOptions.beforeUpload) {
            props.uploadOptions.beforeUpload(handleFileUploadWithOverride(Object.assign(Object.assign({}, props.uploadOptions), { onLoad: handleOnLoad })), files);
        }
        else {
            if (props.inChunks) {
                handleFileUploadInChunks(Object.assign(Object.assign({}, props.uploadOptions), { onLoad: onLoadWrapper, onSuccess: onSuccessWrapper, onError: onErrorWrapper, overwrite: isUndefined(props.uploadOptions.overwrite)
                        ? true
                        : props.uploadOptions.overwrite }))(files);
            }
            else {
                handleFileUpload(Object.assign(Object.assign({}, props.uploadOptions), { onLoad: onLoadWrapper, onSuccess: onSuccessWrapper, onError: onErrorWrapper, overwrite: isUndefined(props.uploadOptions.overwrite)
                        ? true
                        : props.uploadOptions.overwrite }))(files);
            }
        }
    };
    return props.children({ file, upload, onRemove });
};
export const UploadInputProvider = ({ children, onSelect, multiple = false, fileTypes, maxFiles, setExceedMaxFilesLimit, }) => {
    const acceptTypes = fileTypes === null || fileTypes === void 0 ? void 0 : fileTypes.join(", ");
    const inputRef = createRef();
    const onDrop = useCallback((droppedFiles) => {
        if (multiple && maxFiles === 0) {
            setExceedMaxFilesLimit === null || setExceedMaxFilesLimit === void 0 ? void 0 : setExceedMaxFilesLimit(true);
        }
        else if (multiple &&
            !!maxFiles &&
            droppedFiles.length > maxFiles) {
            setExceedMaxFilesLimit === null || setExceedMaxFilesLimit === void 0 ? void 0 : setExceedMaxFilesLimit(true);
            onSelect(droppedFiles.slice(0, maxFiles));
        }
        else {
            onSelect(droppedFiles);
        }
    }, [onSelect]);
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
            onDrop(acceptedFiles);
        },
        multiple,
    });
    const handleInputChange = (event) => {
        if (!isNull(event.target.files)) {
            if (multiple && maxFiles === 0) {
                setExceedMaxFilesLimit === null || setExceedMaxFilesLimit === void 0 ? void 0 : setExceedMaxFilesLimit(true);
            }
            else if (multiple &&
                !!maxFiles &&
                Array.from(event.target.files).length > maxFiles) {
                setExceedMaxFilesLimit === null || setExceedMaxFilesLimit === void 0 ? void 0 : setExceedMaxFilesLimit(true);
                onSelect(Array.from(event.target.files).slice(0, maxFiles));
            }
            else {
                onSelect(Array.from(event.target.files));
            }
        }
        event.target.value = "";
    };
    const onClick = (e) => {
        e.stopPropagation();
        if (inputRef.current) {
            inputRef.current.click();
            inputRef.current.value = "";
        }
    };
    const input = (React.createElement("input", Object.assign({}, getInputProps(), { id: "image", "aria-label": "Upload", type: "file", multiple: multiple, accept: acceptTypes, ref: inputRef, style: { display: "none" }, onChange: handleInputChange })));
    return children({ input, onClick, dropzoneRootProps: getRootProps() });
};
export const FileUploadProvider = ({ uploadOptions, initialUploadedFile, children, inChunks, }) => {
    return (React.createElement(FileUploader, { initialUploadedFile: initialUploadedFile, uploadOptions: uploadOptions, inChunks: inChunks }, ({ file, upload, onRemove }) => (React.createElement(UploadInputProvider, { onSelect: upload, fileTypes: uploadOptions.fileTypes, multiple: uploadOptions.multiple }, ({ input, onClick, dropzoneRootProps }) => children({
        input,
        file,
        onClick,
        onRemove,
        dropzoneRootProps,
    })))));
};
//# sourceMappingURL=FileUploaders.js.map